import React from "react";
import { Navigate, Route } from "react-router-dom";
import { UseAuthContext } from "../store/contexts/auth.context";

function PrivateRoute({ children }) {
  const { isLogged } = UseAuthContext();
  return isLogged ? children : <Navigate to="/signin" replace />;
}

export default PrivateRoute;
